import { inject } from '@angular/core';
import { take, throwError } from 'rxjs';
import { WageService } from 'src/app/core/services/wage/wage.service';
import { LCPUserService } from 'src/app/shared/services/lcp-user/lcp-user.service';
import { MasterWagesCollectionSegment } from '../interfaces/get-master-wages-vars.interface';
import { ApolloQueryResult } from '@apollo/client';
import { ResolveFn } from '@angular/router';

export const masterWagesResolver: ResolveFn<
  ApolloQueryResult<MasterWagesCollectionSegment>
> = (route, _) => {
  const _lcpTenantIdService = inject(LCPUserService);
  const _wageService = inject(WageService);
  const wageDeterminationModificationId = route.paramMap.get(
    'wageDeterminationModificationId'
  );
  const constructionTypeId = route.paramMap.get('constructionTypeId');
  const jurisdictionLocationId = route.paramMap.get('jurisdictionLocationId');

  const tenantId = _lcpTenantIdService.getUserTenantIdValue();

  if (!wageDeterminationModificationId) {
    return throwError(
      () =>
        new Error(
          'No Wage Determination Modification Id was provided. Please Contact Support.'
        )
    );
  }

  if (!jurisdictionLocationId) {
    return throwError(
      () =>
        new Error(
          'No Jurisdiction Location Id was provided. Please Contact Support.'
        )
    );
  }

  return _wageService
    .getMasterWages({
      jurisdictionLocationId,
      tenantId,
      take: 1,
      where: {
        and: [
          {
            constructionTypeId: {
              eq: constructionTypeId,
            },
            modificationId: {
              eq: wageDeterminationModificationId,
            },
          },
        ],
      },
    })
    .pipe(take(1));
};
